// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_np-0";
export var buttonContainer = "_np-3";
export var cancelButton = "_np-4";
export var headerSection = "_np-6";
export var headerTitle = "_np-9";
export var messageSideLeft = "_np-1";
export var messageSideRight = "_np-2";
export var orderNumberContainer = "_np-7";
export var orderNumberLabel = "_np-8";
export var submitButton = "_np-5";